// removed by extract-text-webpack-plugin
module.exports = {"formContainer":"Template--formContainer--3Oua8vuC","buttonContainer":"Template--buttonContainer--2U6wG5B1","authCard":"Template--authCard--2aYZSdgE","card":"Template--card--3-OCGK3S","submitButton":"Template--submitButton--2StbaCKE"};


//////////////////
// WEBPACK FOOTER
// ./src/App/auth/components/Template.css
// module id = 1307
// module chunks = 2